import type { DayNoteExport } from '@daynote/core';
import { http } from './http';
import type { ImportSummary } from '../data/types';

export const transferApi = {
  /** 导出云端全量数据 */
  exportAll(): Promise<DayNoteExport> {
    return http.get('/transfer/export');
  },

  /** 导入数据到云端（合并 + 去重），返回操作摘要 */
  importAll(payload: DayNoteExport): Promise<ImportSummary> {
    return http.post('/transfer/import', payload);
  },
};
